/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { AbstractObject, uuid } from '@src/app/model/abstract-object';
import { Schedule } from '@src/app/model/schedule';
import { Unit } from '@src/app/model/unit';

export class SchedulePortion extends AbstractObject {
    scheduleId: uuid;
    schedule?: Schedule;
    unitId: uuid;
    unit: Unit;
    portion: number;
    percent: number;
    constructor(data: Partial<SchedulePortion>) {
        super(data);
    }
}
